import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '@sb/library/button';
import { IconModule } from '@sb/library/icon';
import { LayoutModule } from '@sb/library/layout';
import { ActionClosableSnackbarComponent } from './action-closable-snackbar/action-closable-snackbar.component';
import { SnackbarComponent } from './snackbar.component';

@NgModule({
    declarations: [
        SnackbarComponent,
        ActionClosableSnackbarComponent
    ],
    imports: [
        CommonModule,
        LayoutModule,
        IconModule,
        ButtonModule
    ]
})
export class SnackbarModule { }
